import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { appConfig } from '../../../core/core-config';

@Component({
  selector: "sot-errorpage",
  templateUrl: "./errorpage.component.html",
  styleUrls: ["./errorpage.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorpageComponent implements OnInit, OnDestroy {

  public version: string = "";

  public constructor(private _changeDetectorRef: ChangeDetectorRef) { 
    console.debug("--- sot-errorpage constructor")
  }

  public ngOnInit(): void {
    console.debug("--- sot-errorpage ngOnInit")
    this.version = appConfig.version;
    this.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-errorpage ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      console.error("ErrorpageComponent.PushChanges > _changeDetectorRef.detectChanges (catch)", e);
    }
  }
}

